<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
        <!-- HEADER -->
        <div 
            class="header p-24 fundo_cinza" 
            fxLayout="row" 
            fxLayoutAlign="space-between center">

            <div fxLayout="column" fxLayoutAlign="center start">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="secondary-text s-18" style="color: #fff;">home</mat-icon>
                    <mat-icon class="secondary-text s-16" style="color: #fff;">chevron_right</mat-icon>
                    <span class="secondary-text pointer" style="color: #fff; cursor: pointer;" (click)="retornarLista()">Lista de Boletas Única</span>
                </div>
                <div class="h1 mt-16">Cadastro de Boleta Única</div>
            </div>
    
            <button 
                mat-raised-button
                class="save-product-button"
                [disabled]="isInvalidForm()"
                *ngIf="data == null && data == undefined"
                (click)="openConfirmaBoleta()">
                <span>Cadastrar</span>
            </button>
    
            <button 
                mat-raised-button
                class="save-product-button"
                [disabled]="isInvalidForm()"
                *ngIf="data != null && data != undefined && tipo !== 'Visualizar'"
                (click)="openConfirmaBoleta()">
                <span>Alterar</span>
            </button>    
            
        </div>
        <!-- END HEADER-->
    
        <div class="content p-24">
            
            <form fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">
                
                <div fxLayout="row" fxLayoutAlign="start" fxFlex="1 0 auto">
                   
                    <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 50%; float:left" >    
                        
                        <div class="h2 mb-24">Escolha um cliente</div>              
    
                        <div fxLayout="row" fxLayoutAlign="space-between">
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Cliente</mat-label>
                                <input matInput placeholder="Digite o nome ou conta de um cliente" aria-label="Cliente"  [formControl]="cliente" name="cliente" required [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                                    <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                                        <span> {{cliente.nome}}</span> |
                                        <small>Conta: {{cliente.numero_xp }} | </small>
                                        <small>Assessor: {{cliente.assessor ? cliente.assessor.name : '' }} </small>
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
                                <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
                            </mat-form-field>
                        </div>
                    </div>
                </div><br/>

                <div fxLayout="row" fxLayoutAlign="start" fxFlex="1 0 auto">
                    <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 100%; float:left">
                        <div class="h2 mb-24">
                            <span>Informações da Boleta</span>                           
                        </div>

                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">                        
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="33" style="margin-right: 10px;">
                                <mat-label>Data da Operação</mat-label>
                                <input matInput [matDatepicker]="picker" [formControl]="data_operacao" name="data_operacao" placeholder="Data da Operação">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="33" style="margin-right: 10px;">
                                <mat-label>Tipo</mat-label>                                    
                                <mat-select                                        
                                    [(value)] = "model.tipo_ativo" 
                                    [formControl] = "tipo_ativo"
                                    name = "tipo_ativo"
                                    (selectionChange) = "tipoChange($event)"
                                    required >
                                    <mat-option value=''>Selecione</mat-option>
                                    <mat-option value='C'>Compra</mat-option>
                                    <mat-option value='V'>Venda</mat-option>
                                    <mat-option value='T'>Transferência</mat-option>
                                    <mat-option value='B'>Bloqueio</mat-option>
                                </mat-select>                                    
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="33">
                                <mat-label>Ação Comercial</mat-label>
                                <mat-select             
                                    [(value)]="model.acao_comercial_id"
                                    [formControl]="acao_comercial_id">
                                    <mat-option value=''>Selecione</mat-option>
                                    <mat-option *ngFor="let acaoComercial of listAcaoComercial" [value]="acaoComercial.id">
                                        {{ acaoComercial.nome }}
                                    </mat-option>
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerAcaoComercial"></mat-spinner> 
                            </mat-form-field>
                        </div>
                        
                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data != null && data != undefined && (user.role_id == 2 || user.role_id == 4 || user.role_id == 7 )  ">
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" style="margin-right: 10px;">
                                <mat-label>Status</mat-label>
                                <input matInput *ngIf="!data" [formControl]="statusBoleta" [readonly]="true">
                                <mat-select 
                                    placeholder="Status"
                                    [(value)]="model.status_id" 
                                    [formControl]="status_id"
                                    name="status_id"
                                    *ngIf="data" >
                                    <mat-option *ngFor="let status of listStatus" [value]="status.id">{{status.nome}}</mat-option>
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>
                            </mat-form-field>
                        </div>
                    </div>
                </div><br/>

                <div fxLayout="row" fxLayoutAlign="start" fxFlex="1 0 auto">
             
                    
                    <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 50%; float:left" >                        

                        <div class="h2 mb-24">
                            <span>Informações da Custódia</span>                        
                            <button 
                                mat-mini-fab
                                class="save-product-button"                                
                                (click)="addAtivo()"
                                style="float: right;"
                                matTooltip="Adicionar Ativo"
                                *ngIf="tipo !== 'Visualizar' ">
                                <mat-icon>add</mat-icon>                                
                            </button>
                        </div>

                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="!desativaOpcoes">
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" style="margin-right: 10px;">
                                <mat-label>Custódia</mat-label>                               
                                <mat-select 
                                    placeholder="Custódia"
                                    [(value)]="model.custodia_id" 
                                    [formControl]="custodia_id"
                                    name="custodia_id">
                                    <mat-option *ngFor="let custodia of listCustodia" [value]="custodia">{{custodia.ativo}} - Qtd: {{custodia.qtd}} - Preço Exec: {{custodia.preco_executado | number : '1.2-2'}}</mat-option>
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerCustodia"></mat-spinner>
                            </mat-form-field>
                        </div>

                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="desativaOpcoes">
                            <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
                                <mat-label>Ativo</mat-label>
                                <input matInput placeholder="Digite o ativo" aria-label="Ativo"  [formControl]="ativo" name="ativo" [matAutocomplete]="auto2">
                                <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnAtivo"  (optionSelected)='getAtivo($event.option.value)'>
                                    <mat-option *ngFor="let ativo of filteredOptionsAtivo | async" [value]="ativo">
                                        <span>Empresa: {{ativo.nome}}</span> |
                                        <small>Sigla: {{ativo.sigla }}</small>
                                    </mat-option>
                                </mat-autocomplete>            
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerAtivos"></mat-spinner>
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="space-between" *ngIf='desativaOpcoes'>
                            <mat-radio-group [formControl]="tipo_preco" fxLayout="row" style="width: 100%;" (change)="precoChange($event)">
                                <mat-radio-button value="definir_preco" class="py-8" style="width: 50%;">
                                    <span class="mat-h4 m-0">Definir Preço</span>
                                </mat-radio-button>                    
                                <mat-radio-button value="valor_mercado" class="py-8" style="margin-right: 20px;">
                                    <span class="mat-h4 m-0">Valor a Mercado</span>                        
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="space-between" *ngIf='ativaVenda'>
                            <mat-radio-group [formControl]="tipo_posicao" fxLayout="row" style="width: 100%;" (change)="seguraPrecoChange($event)">
                                <mat-radio-button value="segura" class="py-8" style="width: 50%;" disabled>
                                    <span class="mat-h4 m-0">Bloquear Custódia</span>
                                </mat-radio-button>                    
                                <mat-radio-button value="disponivel" class="py-8" style="margin-right: 20px;">
                                    <span class="mat-h4 m-0">Disponivel P/ Venda</span>                        
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="space-between" *ngIf='desativaOpcoes'>
                            <mat-radio-group 
                                [formControl]="quantidade_valor" 
                                fxLayout="row" 
                                style="width: 100%;"
                                (change)="quantidadeChange($event)">
                                <mat-radio-button value="definir_qtd" class="py-8" style="width: 50%;">
                                    <span class="mat-h4 m-0">Definir Quantidade</span>
                                </mat-radio-button>                    
                                <mat-radio-button value="informar_valor" class="py-8" style="margin-right: 20px;">
                                    <span class="mat-h4 m-0">Informar Valor Investimento</span>                        
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf='exibePreco'>                        
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" style="margin-right: 10px;">
                                <mat-label>Preço a executar</mat-label>
                                <input matInput placeholder="Preço a executar" [formControl]="preco_executado" name="preco_executado" maxlength="255" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                            </mat-form-field>
                        </div>

                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf='exibeValor'>                        
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" style="margin-right: 10px;">
                                <mat-label>Valor Investimento</mat-label>
                                <input matInput placeholder="Valor Movimentado" [formControl]="valor" name="valor" maxlength="255" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                            </mat-form-field>
                        </div>

                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf='exibeQuantidade'>
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                                <mat-label>Quantidade</mat-label>
                                <input 
                                    matInput 
                                    placeholder="Quantidade" 
                                    [formControl]="qtd" 
                                    name="qtd" 
                                    maxlength="10">
                            </mat-form-field>      
                        </div>

                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                                <mat-label>Observação</mat-label>
                                <input matInput placeholder="Observação" [formControl]="observacao" name="observacao" maxlength="255">
                            </mat-form-field>
                        </div>
                    </div>
                            
                    <div class="mat-card mat-elevation-z4 p-24 mr-24" style="width: 50%; float:left" >
                        <div class="h2 mb-24">Ativos Associados</div>
                        <div class="content-card">
                            <ngx-datatable 
                                #table 
                                class='material striped' 
                                [loadingIndicator]="loadingIndicator"
                                [columns]="columns" 
                                [columnMode]="'force'" 
                                [headerHeight]="50"                       
                                [footerHeight]="50" 
                                [rowHeight]="'auto'"
                                [rows]='rows'>
                
                                <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="false">
                                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                        {{row.ativo_sigla != '' && row.ativo_sigla != undefined ? row.ativo_sigla : row.ativo.sigla }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Quantidade" prop="qtd" [sortable]="false">
                                    <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                                        {{qtd != "" ? (qtd | number : '1.0-0') : "--" }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Preço" prop="preco_compra" [sortable]="false">
                                    <ng-template let-rowIndex="rowIndex" let-preco_compra="value" ngx-datatable-cell-template>
                                        {{preco_compra != "" ? 'R$ '+(preco_compra | number : '1.2-2') : "--" }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Valor Fin." prop="valor" [sortable]="false">
                                    <ng-template let-rowIndex="rowIndex" let-valor="value" ngx-datatable-cell-template>
                                        {{valor != "" ? (valor | number : '1.2-2') : "--" }}
                                    </ng-template>
                                </ngx-datatable-column>
                
                                <ngx-datatable-column name="Ação" prop="id" [sortable]="false" *ngIf="tipo !== 'Visualizar'">
                                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                                        <button mat-icon-button color="warn" matTooltip="Excluir ativo da boleta." (click)="delete(id)">
                                            <mat-icon aria-label="Excluir ativo da boleta">delete</mat-icon>
                                        </button>
                                    </ng-template>
                                </ngx-datatable-column>
                
                            </ngx-datatable>
                            <div style="padding: 5px 10px">
                                <mat-paginator 
                                    #paginator 
                                    [length]="length"
                                    [pageSize]="pageSize"
                                    [pageSizeOptions]="pageSizeOptions">
                                </mat-paginator>
                            </div>             
                        </div>                                 
                    </div>                    
                </div>    
            </form>
        </div>
    </div>
    